import { AnalysisReportEvents } from "shared/types";
import { getText } from "shared/lib";

import { type CalloutAction } from "@/components/wizard/widgets/routingStep/hooks";

import { Button, TemplateRenderer } from "shared/components";

export interface OffTopicPanelProps {
  actions?: Array<CalloutAction>;
  content?: string;
  title?: string;
}

export function OffTopicPanel({ actions, content, title }: OffTopicPanelProps) {
  return (
    <div
      className="flex flex-col gap-5 rounded-xl p-5 shadow-[0px_0px_1px_0px_rgba(0,0,0,0.20),0px_26px_80px_0px_rgba(0,0,0,0.20)] md:max-w-[600px] md:p-8"
      data-testid="off-topic-panel"
    >
      <div className="text-textPrimary [&_a]:text-textLink [&_a]:hover:text-textLinkHover [&_a]:text-bodymd [&_p]:text-bodymd [&_h1]:text-heading2xl flex flex-col gap-3 [&_a]:underline [&_a]:underline-offset-4">
        {title ? <h1>{title}</h1> : null}

        <div>
          <TemplateRenderer
            template={content || ""}
            renderFunctions={{
              restart_conversation: () => {
                return (
                  <a
                    className="text-textLink hover:text-textLinkHover cursor-pointer underline"
                    onClick={() => {
                      const customEvent = new CustomEvent(
                        AnalysisReportEvents.RESTART_CONVERSATION,
                      );
                      document.dispatchEvent(customEvent);
                    }}
                  >
                    {getText("restart")}
                  </a>
                );
              },
            }}
          />
        </div>

        <div className="flex justify-end gap-2.5">
          {actions?.map((action) => {
            const isLastAction =
              actions?.indexOf(action) === actions.length - 1;

            return (
              <Button
                key={action.name}
                onClick={() => {
                  switch (action.action_type) {
                    case "open_tab":
                      window.open(action.url, "_blank");
                      break;
                    case "restart":
                      const customEvent = new CustomEvent(
                        AnalysisReportEvents.RESTART_CONVERSATION,
                      );
                      document.dispatchEvent(customEvent);
                      break;
                  }
                }}
                variant={isLastAction ? "default" : "outline"}
              >
                {action.name}
              </Button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
